import { descriptorsFactory } from '../../utils/filters';

export const apartmentTypeDescriptors = descriptorsFactory({ name: 'IsApartment', clear: ['is_apartment'] })(
  {
    form: [{ key: 'is_apartment', value: false, type: 'term' }],
    label: 'Без апартаментов',
    state: 'Off',
  },
  {
    form: [{ key: 'is_apartment', value: true, type: 'term' }],
    label: 'Только апартаменты',
    state: 'On',
  },
  {
    form: [],
    label: 'Без фильтра',
    state: '',
  },
);
